
import { mapGetters } from 'vuex'
import TablePromotion from '@/components/TablePromotion/index.vue'
import html2canvas from 'html2canvas'
import { copyToClip } from '~/utils/index'

export default {
	name: 'PromotionDetail',
	components: {
		TablePromotion
	},
	data() {
		return {
			// 我的推广信息
			myInfo: {},
			friendNumber: 0,
			groupNumber: 0,
			myPopularizerList: [],
			myInviteFriendList: [],
			myInviteGroupList: [],
			// 底部抽屉显示状态
			bottomDialogShow: false,
			// 分享方式
			shareType: 0,
			// 二维码链接
			qrCodeUrl: '',
			// 身份
			userIdentity: '',

			// 分页相关变量
			loading: false,
			hasMore: true,
			currentPage: 1,
			pageSize: 10,

			/**
			 * 推广返利页面
			 * 功能：展示游戏返利信息，提供推广员注册和小组加入功能
			 */
			tabList: ['我的奖励', '我邀请注册', '推广小组成员'],
			// 根据路由参数初始化当前标签页，默认为0
			currentTab: parseInt(this.$route.query.type) || 0
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			userAccount: 'user/userAccount',
			defaultAvatar: 'user/defaultAvatar'
		}),
		// 用户信息对象，兼容不同的属性名
		userInfo() {
			return this.userinfo || {}
		}
	},
	methods: {
		getInfo() {
			this.$api.getMyPopularizer().then(res => {
				if (res.success) {
					this.myInfo = res.data
					this.qrCodeUrl = `${window.location.origin}/login?inviteCode=${this.myInfo.inviteCode}`
				}
			})
		},
		getFriendNumber() {
			this.$api.getMyInviteFriend().then(res => {
				if (res.success) {
					this.friendNumber = res.data.inviteNum
				}
			})
		},
		getGroupNumber() {
			this.$api.getMyInviteGroup().then(res => {
				if (res.success) {
					this.groupNumber = res.data.groupNum
				}
			})
		},

		// 获取我的奖励列表
		getMyPopularizer(isLoadMore = false) {
			if (this.loading) return
			this.loading = true

			this.$api
				.getMyPopularizerList({
					action: {},
					order: 'DESC',
					page: isLoadMore ? this.currentPage : 1,
					pageSize: this.pageSize,
					sort: 'create_time'
				})
				.then(res => {
					if (res.success) {
						const newData = res.data.records || []

						if (isLoadMore) {
							this.myPopularizerList = [...this.myPopularizerList, ...newData]
						} else {
							this.myPopularizerList = newData
							this.currentPage = 1
						}

						this.hasMore = newData.length === this.pageSize
					}
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 我邀请的好友列表
		getMyInviteFriend(isLoadMore = false) {
			if (this.loading) return
			this.loading = true

			this.$api
				.getMyInviteFriendList({
					action: {},
					order: 'DESC',
					page: isLoadMore ? this.currentPage : 1,
					pageSize: this.pageSize,
					sort: 'create_time'
				})
				.then(res => {
					if (res.success) {
						const newData = res.data.records || []

						if (isLoadMore) {
							this.myInviteFriendList = [...this.myInviteFriendList, ...newData]
						} else {
							this.myInviteFriendList = newData
							this.currentPage = 1
						}

						this.hasMore = newData.length === this.pageSize
					}
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 我邀请的组员列表
		getMyInviteGroup(isLoadMore = false) {
			if (this.loading) return
			this.loading = true

			this.$api
				.getMyInviteGroupList({
					action: {},
					order: 'DESC',
					page: isLoadMore ? this.currentPage : 1,
					pageSize: this.pageSize,
					sort: 'create_time'
				})
				.then(res => {
					if (res.success) {
						const newData = res.data.records || []

						if (isLoadMore) {
							this.myInviteGroupList = [...this.myInviteGroupList, ...newData]
						} else {
							this.myInviteGroupList = newData
							this.currentPage = 1
						}

						this.hasMore = newData.length === this.pageSize
					}
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 根据当前标签页调用对应的接口
		loadCurrentTabData(isLoadMore = false) {
			if (!isLoadMore) {
				// 重置分页状态
				this.currentPage = 1
				this.hasMore = true
			}

			switch (this.currentTab) {
				case 0:
					// 我的奖励
					this.getMyPopularizer(isLoadMore)
					break
				case 1:
					// 我邀请注册
					this.getMyInviteGroup(isLoadMore)
					break
				case 2:
					// 推广小组成员
					this.getMyInviteFriend(isLoadMore)
					break
				default:
					break
			}
		},

		// 切换标签页时的处理函数
		switchTab(index) {
			this.currentTab = index
			this.loadCurrentTabData()
		},

		// 加载更多
		loadMore() {
			if (this.loading || !this.hasMore) return

			this.currentPage += 1
			this.loadCurrentTabData(true)
		},

		// 获取当前标签页对应的表格数据
		getCurrentTableData() {
			switch (this.currentTab) {
				case 0:
					return this.myPopularizerList
				case 1:
					return this.myInviteGroupList
				case 2:
					return this.myInviteFriendList
				default:
					return []
			}
		},
		openShare(type) {
			if (type == 0) {
				this.shareType = 0
				this.$trackEvent({
					eventType: 'click',
					trackParams: {
						eventName: '分享好友'
					}
				})
			} else {
				this.shareType = 1
				this.$trackEvent({
					eventType: 'click',
					trackParams: {
						eventName: '邀请组员'
					}
				})
			}
			this.bottomDialogShow = true
		},
		copyShareLink() {
			if (this.qrCodeUrl) {
				copyToClip(this.qrCodeUrl, '分享链接已复制')
			} else {
				showToast('链接生成中，请稍后重试')
			}
		},
		// 保存分享图片
		async saveShareImage() {
			const elementClass = this.shareType === 0 ? 'overlay_my_box' : 'overlay_group_box'
			const node = document.querySelector(`.${elementClass} .box_content`)
			this.exportToImage(node, '盼之代售分享海报')
		},
		async exportToImage(exportContent, title) {
			if (!exportContent) {
				this.$message.warning('未找到要导出的内容')
				return
			}

			try {
				// 显示加载状态
				const loading = this.$loading({
					lock: true,
					text: '正在生成图片...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})

				let canvas = null
				let success = false

				// 方案1: 使用 modern-screenshot (推荐)
				try {
					const { domToCanvas } = await import('modern-screenshot')
					canvas = await domToCanvas(exportContent, {
						backgroundColor: '#ffffff',
						scale: 2, // 提高清晰度
						quality: 0.95,
						style: {
							transform: 'scale(1)',
							transformOrigin: 'top left'
						}
					})
					success = true
					console.log('使用 modern-screenshot 成功')
				} catch (error) {
					console.warn('modern-screenshot 失败:', error)
				}

				// 方案2: 使用 dom-to-image 作为备选
				if (!success) {
					try {
						const domtoimage = await import('dom-to-image')
						const dataUrl = await domtoimage.toPng(exportContent, {
							bgcolor: '#ffffff',
							quality: 0.95,
							style: {
								transform: 'scale(2)',
								transformOrigin: 'top left'
							},
							width: exportContent.offsetWidth * 2,
							height: exportContent.offsetHeight * 2
						})

						// 创建 canvas
						canvas = document.createElement('canvas')
						const ctx = canvas.getContext('2d')
						const img = new Image()

						await new Promise((resolve, reject) => {
							img.onload = () => {
								canvas.width = img.width
								canvas.height = img.height
								ctx.drawImage(img, 0, 0)
								resolve()
							}
							img.onerror = reject
							img.src = dataUrl
						})

						success = true
						console.log('使用 dom-to-image 成功')
					} catch (error) {
						console.warn('dom-to-image 失败:', error)
					}
				}

				// 方案3: 使用 html2canvas 作为最后备选
				if (!success) {
					try {
						const html2canvas = await import('html2canvas')
						canvas = await html2canvas.default(exportContent, {
							backgroundColor: '#ffffff',
							scale: 2,
							useCORS: true,
							allowTaint: true,
							logging: false,
							imageTimeout: 15000
						})
						success = true
					} catch (error) {
						console.error('html2canvas 也失败了:', error)
					}
				}

				loading.close()

				if (!success || !canvas) {
					this.$message.error('图片生成失败，请重试')
					return
				}

				// 下载图片
				this.downloadCanvasAsImage(canvas, title)
			} catch (error) {
				this.$message.error('图片生成失败: ' + error.message)
			}
		},
		// 下载 canvas 为图片
		downloadCanvasAsImage(canvas, title) {
			try {
				const link = document.createElement('a')
				link.download = `${title}_${new Date().getTime()}.png`
				link.href = canvas.toDataURL('image/png', 0.95)
		 		document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			} catch (error) {
				console.error('下载图片失败:', error)
				// 备选方案：在新窗口打开图片
				const newWindow = window.open()
				newWindow.document.write(`<img src="${canvas.toDataURL('image/png', 0.95)}" style="max-width:100%;"/>`)
			}
		},
		// 获取当前标签页对应的表格类型
		getCurrentTableType() {
			switch (this.currentTab) {
				case 0:
					return 'reward'
				case 1:
					return 'group'
				case 2:
					return 'friend'
				default:
					return 'reward'
			}
		},

		// 返回上一级页面
		goBack() {
			this.$router.push('/promotionRebate')
		}
	},

	mounted() {
		this.getInfo()
		this.getFriendNumber()
		this.getGroupNumber()
		// 根据初始标签页加载对应数据
		this.loadCurrentTabData()
		this.$api.getUserIdentity().then(res => {
			if (res.success) {
				this.userIdentity = res.data.idenType
				this.tabList = this.userIdentity === 'POPULARIZER' ? ['我的奖励', '我邀请注册', '推广小组成员'] : ['我的奖励', '我邀请注册']
			}
		})
	}
}
